/**
 * RandomTile Part
 * Selects a random tile from a list at runtime
 */

import { Part } from '../Part';
import { Events } from '../types';
import { Render } from './Render';
import { random } from '@/utils/Random';

/**
 * RandomTile part
 * On object creation, selects one tile from the configured list
 */
export class RandomTile extends Part {
  readonly name = 'RandomTile';

  /** Comma-separated list of tile paths */
  tiles: string = '';

  constructor(params: Record<string, unknown> = {}) {
    super();
    if (params.Tiles !== undefined) {
      this.tiles = String(params.Tiles);
    }
  }

  onEvent(event: string, _data?: unknown): boolean {
    if (event === Events.OBJECT_CREATED) {
      this.setupTile();
    }
    return true;
  }

  private setupTile(): void {
    if (!this.tiles) return;

    const render = this.parent?.getPart<Render>('Render');
    if (!render) return;

    // Parse tile list
    const tileList = this.tiles.split(',').map((t) => t.trim());
    if (tileList.length === 0) return;

    // Pick a random tile
    render.tile = random.choice(tileList);
  }
}

/**
 * Factory for creating RandomTile parts
 */
export function createRandomTile(params: Record<string, unknown>): RandomTile {
  return new RandomTile(params);
}
